
<mat-form-field class="form-field" appearance="fill" [ngClass]="{'mat-field-has-error': hasError}">
  <mat-label>{{ label }}</mat-label>
  <input
    matInput
    [id]="id"
    [type]="type"
    (focus)="onInput($event)"
    (input)="onInput($event)"
    (keyup)="updateValue()"
    (blur)="onBlurValue($event)"
    [value]="value"
    [disabled]="isDisabled || disabled"
    [attr.maxlength]="maxlength"
    [attr.required]="required"
    [attr.inputmode]="inputmode"
    [attr.pattern]="regex"
  />
  <span *ngIf="iconCheck">
    <img src="/assets/icons/check_green.svg" alt="Icono Exitoso" />
  </span>

  <span *ngIf="iconBlock" class="block">
    <img src="/assets/icons/block.svg" alt="Icono Bloqueado" />
  </span>

  <span *ngIf="iconError">
    <img src="/assets/icons/check_error.svg" alt="Icono Error" />
  </span>

  <span *ngIf="spinner" class="loader">
    <img src="/assets/gifs/spinner.gif" alt="Icono Error" />
  </span>

  <span *ngIf="flag" class="flag">
    <img src="/assets/icons/colombia_flag.svg" alt="Icono Error" />
  </span>
</mat-form-field>
